import { all, put, takeEvery, fork } from 'redux-saga/effects'
import { loadingStart, loadingStop } from './action'
import ProfileSaga from './profile/saga'
import JobSearchSaga from './search/saga'
import {getFirebase} from 'react-redux-firebase'
import {push} from 'react-router-redux'
import TestSaga from './test/saga';
function* signinRequest() {
    yield put(loadingStart('โหลดข้อมูลผู้ใช้...'))
}

function* stopLoading() {
    yield put(loadingStop())
}

function* startTest() {
    getFirebase().updateProfile({
        currentTest: 'cognitive',
        currentIndex: 0,
        startTime: Date.now(),
    }, yield put(push('/test')))
    
}

function* signinSaga() {
    yield takeEvery('@@reactReduxFirebase/LOGIN', signinRequest)
    yield takeEvery('@@reactReduxFirebase/SET_PROFILE', stopLoading)
    yield takeEvery('@@reactReduxFirebase/AUTH_EMPTY_CHANGE', stopLoading)
    yield takeEvery('@@test/START', startTest)

}

export default function* Saga() {
    yield all([
        fork(signinSaga),
        fork(ProfileSaga),
        fork(JobSearchSaga),
        fork(TestSaga)
    ])
}



// WEBPACK FOOTER //
// ./src/saga.js